import React, {Fragment} from 'react';

import clsx from 'clsx';

import PerfectScrollbar from 'react-perfect-scrollbar';
import {Hidden, Drawer, Paper} from '@material-ui/core';

import {connect} from 'react-redux';

import {useTranslation} from 'react-i18next';
import {
  setSidebarToggleMobile as setSidebarToggleMobileAction,
  setSidebarHover as setSidebarHoverAction,
  setSidebarToggle as setSidebarToggleAction,
  setSidebarFooter as setSidebarFooterAction,
  setSidebarUserbox as setSidebarUserboxAction,
} from 'store/reducers/ThemeOptions';
import SidebarHeader from '../SidebarHeader';
import SidebarUserbox from '../SidebarUserbox';
import SidebarMenu from '../SidebarMenu';
import navItems from './navItems';

const Sidebar = (props) => {
  const {t} = useTranslation();
  const {
    setSidebarToggleMobile,
    sidebarToggleMobile,
    sidebarFixed,

    sidebarHover,
    setSidebarHover,
    sidebarToggle,
    // sidebarUserbox,
    sidebarShadow,
    // sidebarFooter
  } = props;

  const toggleHoverOn = () => setSidebarHover(true);
  const toggleHoverOff = () => setSidebarHover(false);
  const closeDrawer = () => setSidebarToggleMobile(!sidebarToggleMobile);
  const sidebarMenuContent = (
    <div>
      {navItems.map((list) => (
        <SidebarMenu
          pms={props.pms}
          configs={props.configs}
          component="div"
          key={list.label}
          pages={list.content}
          title={t(list.label)}
        />
      ))}
    </div>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggleMobile}
          onClose={closeDrawer}
          variant="temporary"
          elevation={4}
          className="app-sidebar-wrapper-lg">
          <SidebarHeader />
          <PerfectScrollbar>
            <SidebarUserbox companyConfigs={props.companyConfigs} />
            {sidebarMenuContent}
          </PerfectScrollbar>
        </Drawer>
      </Hidden>

      <Hidden mdDown>
        <Paper
          onMouseEnter={toggleHoverOn}
          onMouseLeave={toggleHoverOff}
          className={clsx('app-sidebar-wrapper', {
            'app-sidebar-wrapper-close': sidebarToggle,
            'app-sidebar-wrapper-open': sidebarHover,
            'app-sidebar-wrapper-fixed': sidebarFixed,
          })}
          square
          open={sidebarToggle}
          elevation={sidebarShadow ? 11 : 3}>
          <SidebarHeader />
          <div
            className={clsx({
              'app-sidebar-menu': sidebarFixed,
              'app-sidebar-collapsed': sidebarToggle && !sidebarHover,
            })}>
            <PerfectScrollbar options={{wheelPropagation: false}}>
              <SidebarUserbox
                bar={props.bar}
                companyConfigs={props.companyConfigs}
              />
              {sidebarMenuContent}
            </PerfectScrollbar>
          </div>
        </Paper>
      </Hidden>
    </>
  );
};

const mapStateToProps = (state) => ({
  sidebarFixed: state.ThemeOptions.sidebarFixed,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarHover: state.ThemeOptions.sidebarHover,
  sidebarShadow: state.ThemeOptions.sidebarShadow,
  sidebarFooter: state.ThemeOptions.sidebarFooter,
  sidebarUserbox: state.ThemeOptions.sidebarUserbox,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
});

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggleMobile: (enable) =>
    dispatch(setSidebarToggleMobileAction(enable)),
  setSidebarToggle: (enable) => dispatch(setSidebarToggleAction(enable)),
  setSidebarHover: (enable) => dispatch(setSidebarHoverAction(enable)),
  setSidebarFooter: (enable) => dispatch(setSidebarFooterAction(enable)),
  setSidebarUserbox: (enable) => dispatch(setSidebarUserboxAction(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
